// extracted by mini-css-extract-plugin
module.exports = {"addNewGroup":"AddNewGroup_addNewGroup__3pHbg","groupImage":"AddNewGroup_groupImage__25zQG","errorMsg":"AddNewGroup_errorMsg__3E2be"};